import type { Language } from '../types';

export const translations = {
  en: {
    nav: {
      ABOUT: 'About',
      HOW_TO: 'How to use',
      GET_ACC_REC: 'Getting accurate recognition',
      IDENTIFY: 'Identify Eurygaster',
      NAV: 'Navigation',
      LANG: 'Language',
      CITE: 'How to cite',
      CLOSE: 'Close',
    },
    account: {
      ACC: 'Account',
      GREET: 'Welcome',
      EMAIL: 'Email',
      USERNAME: 'User',
      SIGN_IN: 'Sign In',
      SIGN_OUT: 'Sign Out',
      ACCOUNT_SETTINGS: 'Account settings',
      HELP: 'Help',
      VER: 'Version',
    },
    hints: {
      ASK_IMAGE: 'Please, upload an image file',
      FILTER_DESCR: 'Confidence that this is the picture of Eurygaster spp.:',
      CLASSIFIER_DESCR: 'Confidence distribution of species if Eurygaster is in the picture:',
      INCORRECT_INPUT: 'The input contains undefined data. Perhaps it is a masked file of another data type.',
      EMPTY_INPUT: 'No image input',
      WAS_FILTERED: 'No Eurygaster found in the image',
      RECOGNIZED_AS: 'Found %s with confidence %.3f',
      LOADING_METADATA: 'Loading metadata...',
      CLASSIFYING: 'Classifying...',
      CLASSIFY_IMAGE: 'Classify Image',
      CLICK_TO_UPLOAD: 'Click to upload',
      OR_DRAG_DROP: 'or drag and drop',
      FILE_FORMAT: 'JPEG or JPG (MAX. 50MB)',
      DETAILS: 'Details:',
      CONFIDENCE_PERCENT: 'Confidence (%)',
    },
    login: {
      SIGN_IN: 'Sign In',
      SIGN_OUT: 'Sign Out',
      LABEL_LOGIN: 'Please, sign in to your account',
      ERR_NOPOPUP: 'Unable to open the authentication popup. Allow popups and refresh the page to proceed',
      ERR_POPUPCLOSED: 'Authentication popup was closed manually',
      ERR_FATAL: 'Unable to connect to auth system using the current configuration',
      RECENT_IMAGES: 'Recent Images',
      RECENT_ENTRIES: 'Recent Entries',
    },
  },
  ru: {
    nav: {
      ABOUT: 'О приложении',
      HOW_TO: 'Как пользоваться',
      GET_ACC_REC: 'Рекомендации по фотосъемке',
      IDENTIFY: 'Распознать Eurygaster',
      NAV: 'Навигация',
      LANG: 'Язык',
      CITE: 'Как цитировать',
      CLOSE: 'Закрыть',
    },
    account: {
      ACC: 'Аккаунт',
      GREET: 'Добро пожаловать',
      EMAIL: 'Почта',
      USERNAME: 'Пользователь',
      SIGN_IN: 'Войти',
      SIGN_OUT: 'Выйти',
      ACCOUNT_SETTINGS: 'Настройки аккаунта',
      HELP: 'Помощь',
      VER: 'Версия',
    },
    hints: {
      ASK_IMAGE: 'Пожалуйста, загрузите фотографию',
      FILTER_DESCR: 'Вероятность, что на фотографии Eurygaster spp.:',
      CLASSIFIER_DESCR: 'Распределение вероятностей принадлежности к каждому из видов Eurygaster:',
      INCORRECT_INPUT: 'На вход поданы некорректные данные.',
      EMPTY_INPUT: 'Изображение не загружено',
      WAS_FILTERED: 'На изображении не найдено Eurygaster',
      RECOGNIZED_AS: 'Обнаружен %s с уверенностью %.3f',
      LOADING_METADATA: 'Загрузка метаданных...',
      CLASSIFYING: 'Классификация...',
      CLASSIFY_IMAGE: 'Классифицировать изображение',
      CLICK_TO_UPLOAD: 'Нажмите для загрузки',
      OR_DRAG_DROP: 'или перетащите файл',
      FILE_FORMAT: 'JPEG или JPG (МАКС. 50МБ)',
      DETAILS: 'Детали:',
      CONFIDENCE_PERCENT: 'Уверенность (%)',
    },
    login: {
      SIGN_IN: 'Войти',
      SIGN_OUT: 'Выйти',
      LABEL_LOGIN: 'Пожалуйста, войдите в свой аккаунт',
      ERR_NOPOPUP: 'Невозможно открыть всплывающее окно аутентификации. Разрешите всплывающие окна и обновите страницу, чтобы продолжить',
      ERR_POPUPCLOSED: 'Всплывающее окно аутентификации было закрыто вручную',
      ERR_FATAL: 'Невозможно подключиться к системе аутентификации, используя текущую конфигурацию',
      RECENT_IMAGES: 'Недавние изображения',
      RECENT_ENTRIES: 'Недавние записи',
    },
  },
};

export const getTranslation = (lang: Language) => translations[lang];

